import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { useI18n } from "../../i18n/I18nProvider";
import { ASSETS } from "../../lib/assets";
import { config } from "../../lib/config";

const XIcon = () => <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor" aria-hidden><path d="M18.9 2H22l-7.6 8.7L23 22h-6.8l-5.3-6.9L4.8 22H1.7l8.1-9.3L1 2h7l4.8 6.3L18.9 2Zm-1.2 18h1.9L7.4 4H5.4l12.3 16Z" /></svg>;
export { XIcon };

export function Footer() {
  const { t } = useI18n();
  const cols = [
    [t("footer.explore"), [["nav.home", "/"], ["nav.world", "/world"], ["nav.learn", "/learn"], ["nav.library", "/library"], ["nav.tutor", "/ai-tutor"], ["nav.dashboard", "/dashboard"]]],
    [t("footer.project"), [["nav.about", "/about"], ["nav.community", "/community"], ["nav.contribute", "/contribute"], ["nav.impact", "/impact"], ["nav.token", "/token"], ["nav.contact", "/contact"]]],
    [t("footer.resources"), [["nav.docs", "/docs"], ["nav.faq", "/faq"], ["footer.safety", "/guardians"]]],
    [t("footer.legal"), [["footer.privacy", "/privacy"], ["footer.terms", "/terms"], ["footer.accessibility", "/accessibility"]]],
  ];
  return (
    <footer className="mt-16 rounded-t-[40px] bg-[#123E91] px-6 pb-10 pt-16 text-white lg:px-12" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-10 lg:grid-cols-[1.4fr_repeat(4,1fr)]">
        <div>
          <Link to="/" data-testid="footer-logo-link" className="inline-flex items-center gap-3">
            <img src={ASSETS.logo.src} alt={ASSETS.logo.alt} width={72} height={72} loading="lazy" className="h-[72px] w-[72px] object-contain" />
            <span className="font-heading text-2xl font-black">学无界<span className="block text-xs tracking-widest text-[#FFD84A]">LEARN WITHOUT BORDERS</span></span>
          </Link>
          <p className="mt-4 max-w-xs text-sm text-white/80">{t("footer.mission")}</p>
          <a data-testid="footer-x-link" href={config.social.x} target="_blank" rel="noopener noreferrer" className="mt-5 inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-bold hover:bg-white/20">
            <XIcon /> {config.social.xHandle} <ExternalLink className="h-3.5 w-3.5" />
          </a>
        </div>
        {cols.map(([title, links]) => (
          <div key={title}>
            <p className="mb-3 font-heading text-sm font-extrabold uppercase tracking-wider text-[#FFD84A]">{title}</p>
            <ul className="space-y-2">
              {links.map(([k, to]) => <li key={to}><Link to={to} data-testid={`footer-link-${to.slice(1) || "home"}`} className="text-sm text-white/85 hover:text-white">{t(k)}</Link></li>)}
            </ul>
          </div>
        ))}
      </div>
      <div className="mx-auto mt-12 flex max-w-7xl flex-col gap-3 border-t border-white/15 pt-6 text-xs text-white/70 md:flex-row md:items-center md:justify-between">
        <p>© {new Date().getFullYear()} {t("footer.rights")}</p>
        <p data-testid="footer-token-note">{t("footer.contract")}: <span className="font-bold text-[#FFD84A]">{config.token.contractAddress || "COMING SOON"}</span> · {t("footer.tokenNote")}</p>
      </div>
    </footer>
  );
}
